import React, { useEffect, useState } from 'react';
import css from './css/QuestionBankTable.scss';
import commonCss from './css/SurveyStyle.scss';
import SortableTable from 'SF/table/SortableTable';
import ReactTooltip from 'react-tooltip';
import Icon from 'SF/MaterialIcon';
import { Table } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import {caseInsensitiveSort} from 'utils/text';
import {sortBy} from 'lodash';

const headers = [
    {
        content: 'Question',
        sortValue: 'questionText',
        width: 12
    }, {
        content: 'Question Type',
        sortValue: 'questionType.label',
        width: 2
    }, {
        content: 'Actions',
        width: 2
    }
];

const sortQuestions = (questionList, col, dir) => {
    const sortedQuestions = (col === 'questionText') ?
        caseInsensitiveSort(questionList, col)
        : sortBy(questionList, col);
    return dir === 'ASC' ? sortedQuestions : sortedQuestions.reverse()
};

const QuestionBankTable = ({questions, editQuestion}) => {
    const [sorting, setSorting] = useState({sortCol: 'questionText', dir: 'ASC'});
    const [sortedQuestions, setSortedQuestions] = useState([]);

    useEffect(() => {
        setSortedQuestions(sortQuestions(questions, sorting.sortCol, sorting.dir));
    }, [questions]);

    const onSort = (col, dir) => {
        setSortedQuestions(sortQuestions(sortedQuestions, col, dir));
        setSorting({sortCol: col, dir: dir});
    };

    const renderRow = (question, index) => (
        <Table.Row key={index} data-testid={`questionRow-${index}`}>
            <Table.Cell>{question.questionText}</Table.Cell>
            <Table.Cell>{question.questionType.label}</Table.Cell>
            <Table.Cell className={css['icon-container']}>
                <button type='button'
                        data-tip
                        data-for='edit-tip'
                        aria-label={`Edit ${question.questionText}`}
                        onClick={() => editQuestion(question.id)}
                >
                    <Icon icon='edit' aria-hidden />
                </button>
                <ReactTooltip id='edit-tip' className={commonCss['tooltip']} place='bottom' effect='solid'>
                    Edit Question
                </ReactTooltip>
            </Table.Cell>
        </Table.Row>
    )

    return (
        <SortableTable
            className={commonCss['table']}
            columnToSort={sorting.sortCol}
            sortDirection={sorting.dir}
            onSortChange={onSort}
            headers={headers}
            itemName={'questions'}
            items={sortedQuestions}
            renderItem={renderRow}
            shouldPaginate={false}
            celled
        />
    );
}

QuestionBankTable.propTypes = {
    questions: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        questionText: PropTypes.string.isRequired,
        questionType: PropTypes.object.isRequired
    })).isRequired,
    editQuestion: PropTypes.func.isRequired
};

export default QuestionBankTable;
